import { IGalleryOptions } from '../../types/gallery';

export const GALLERY_OPTIONS: IGalleryOptions = {
  DEFAULT: {
    fit: 'cover',
    thumbwidth: 64,
    thumbheight: 64,
    swipe: false,
    nav: 'thumbs',
    maxHeight: 500,
    ratio: '812/500',
  },
  FULLSCREEN: {
    thumbwidth: 72,
    thumbheight: 56,
    fit: 'contain',
    swipe: true,
    nav: 'thumbs',
  },
};
